module.exports = __webpack_public_path__ + "static/website-icon-1836066d582287953eac73678b53c24b.png";